import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportResourceAllocation_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportResourceAllocation extends Report<ReportResourceAllocation_Settings> {

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_RESOURCE_ALLOCATION
        super(data);

        this.icon        = "isvg-allocation"
        this.description = "The Resource Allocation Report shows resource distribution across tasks and projects, ensuring optimal use and preventing overallocation."

        this.settings    = new ReportResourceAllocation_Settings(data.settings)
    }

    static initFromSavedView(savedView:SavedView): ReportResourceAllocation {
        return new ReportResourceAllocation(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportResourceAllocation_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

}
